import type { BillingGateReason } from "@/types/api";

export function parseBillingReasonFromApiData(
  code: string | undefined,
  data: unknown,
): BillingGateReason | undefined {
  if (code !== "ACCESS_DENIED" || data == null || typeof data !== "object") {
    return undefined;
  }
  const reason = (data as { billing_reason?: unknown }).billing_reason;
  if (reason === "subscription_required" || reason === "upgrade_to_pro_required") {
    return reason;
  }
  return undefined;
}
